import BaseComponent from "./BaseComponent";

import Swiper, { Autoplay, EffectFade, Navigation, Pagination } from 'swiper';

export default class Slider extends BaseComponent {
    constructor() {
        super();

        this._swiper = null;

        this._modules = [ Autoplay, EffectFade, Navigation, Pagination ];

        this._container = '.blb-slider.swiper';

        this._swiperComponent = null;

        this._pagination = '.blb-slider-pagination.swiper-pagination';

        this._buttonNext = '.swiper-button-next';

        this._autoplayControls = null;

        this._isAutoplayRunning = true;

        this._params = null

        this._initSwiper();
    }

    _initSwiper() {
        this._swiperComponent = document.querySelector(this._container);

        if (this._swiperComponent !== null) {
            const params = {
                modules: this._modules,
                speed: 1000,
                loop: true,
                autoHeight: true,
                allowTouchMove: true,
                autoplay: {
                    delay: 7000,
                    disableOnInteraction: false,
                },
                pagination: {
                    el: this._pagination,
                    clickable: true
                },
                navigation: {
                    nextEl: this._buttonNext
                },
                effect: 'fade',
                fadeEffect: {
                    crossFade: true
                },
                a11y: {
                    enabled: true
                }
            };

            this._swiper = new Swiper(this._container, params);

            this._autoplayControls = this._swiperComponent.querySelector('.blb-slider-controls.autoplay-controls');

            this._initAutoplayController();
        }
    }

    _initAutoplayController() {
        this._autoplayControls.addEventListener('pointerup', (e) => {
            if (this._isAutoplayRunning) {
                this._swiper.autoplay.stop();
                this._autoplayControls.classList.add('paused');
                this._isAutoplayRunning = false;
            } else {
                this._swiper.autoplay.start();
                this._autoplayControls.classList.remove('paused');
                this._isAutoplayRunning = true;
            }
        });
    }
}
